<template>
  <nav class="pagination" v-if="maxPage > 1">
    <ol>
      <li :class="`pager rotate-180 ${page === 1 ? 'inactive' : ''}`">
        <i class="icon-arrow-right" @click="page === 1 ? null : $emit('page', page - 1)" />
      </li>
      <li class="page" v-if="!pages.includes(1)" @click="$emit('page', 1)">1</li>
      <li class="separator" v-if="page > 3">
        <span></span>
        <span></span>
        <span></span>
      </li>
      <li :class="`page ${p === page ? 'active' : ''} ${p >= 100 ? 'small-text' : ''} ${p >= 1000 ? 'smallest-text' : ''}`" v-for="(p, index) in pages" :key="index" @click="$emit('page', p)">{{ p }}</li>
      <li class="separator" v-if="page + 2 < maxPage">
        <span></span>
        <span></span>
        <span></span>
      </li>
      <li :class="`page ${maxPage >= 100 ? 'small-text' : ''} ${maxPage >= 1000 ? 'smallest-text' : ''}`" v-if="!pages.includes(maxPage)" @click="$emit('page', maxPage)">{{ maxPage }}</li>
      <li :class="`pager ${page === maxPage ? 'inactive' : ''}`">
        <i class="icon-arrow-right" @click="page === maxPage ? null : $emit('page', page + 1)" />
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      default: 1,
    },
    maxPage: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    /**
     * Pages
     * Figure out pagination between page and maxpage
     * @returns {Array}
     */
    pages() {
      const { maxPage, page } = this;
      const pages = [];

      let max = 4;
      let minus = 2;

      if (this.page > 3) {
        if (page + 2 >= maxPage) {
          if (page === maxPage) {
            max = 4;
            minus = 4;
          } else {
            max = 4;
            minus = page + 1 === maxPage ? 3 : 2;
          }
        } else {
          max = 2;
          minus = 1;
        }
      }

      for (let i = this.page - minus, n = 0; i <= this.page + 6; i += 1) {
        if (i > 0 && i <= this.maxPage && n <= max) {
          n += 1;
          pages.push(i);
        }
      }
      return pages;
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  user-select: none;

  ol {
    align-items: center;
    display: flex;
    justify-content: center;
    list-style: none;

    li {
      align-items: center;
      background-color: #0060ff;
      border-radius: 25px;
      color: white;
      display: flex;
      height: 30px;
      justify-content: center;
      transition: background-color .3s, color .3s, width .3s, height .3s, font-size .3s;
      width: 30px;
      margin: 0 3px;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      &:hover:not(.separator):not(.active):not(.inactive) {
        cursor: pointer;
      }

      &.active, &.inactive {
        background-color: #d9dae5;
        color: white;
      }

      @media (min-width: 768px) {
        margin: 0 4px;
        height: 30px;
        width: 30px;
      }

      @media (min-width: 1024px) {
        margin: 0 5px;
        height: 40px;
        width: 40px;
      }
    }
  }

  .separator {
    background-color: unset;
    color: var(--color-font-semi);
    font-size: 18px;

    span {
      background-color: #848894;
      border-radius: 3px;
      display: inline-block;
      height: 4px;
      width: 4px;

      &:first-child {
        margin-right: 2px;
      }
      &:last-child {
        margin-left: 2px;
      }

      @media (min-width: 768px) {
        height: 5px;
        width: 5px;

        &:first-child {
          margin-right: 3px;
        }
        &:last-child {
          margin-left: 3px;
        }
      }

      @media (min-width: 768px) {
        height: 6px;
        width: 6px;

        &:first-child {
          margin-right: 4px;
        }
        &:last-child {
          margin-left: 4px;
        }
      }
    }
  }

  .pager {
    font-size: 16px;

    @media (min-width: 768px) {
      font-size: 18px;
    }
    @media (min-width: 1024px) {
      font-size: 20px;
    }
  }

  .page {
    font-size: 16px;

    @media (min-width: 768px) {
      font-size: 18px;
    }
    @media (min-width: 1024px) {
      font-size: 20px;
    }

    &.small-text {
      font-size: 13px;

      @media (min-width: 768px) {
        font-size: 16px;
      }
      @media (min-width: 1024px) {
        font-size: 18px;
      }
    }

    &.smallest-text {
      font-size: 12px;

      @media (min-width: 768px) {
        font-size: 14px;
      }
      @media (min-width: 1024px) {
        font-size: 16px;
      }
    }
  }
}
</style>
